import { Box, Typography, Container, Paper, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function ThankYou() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 4 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 6, 
          textAlign: 'center',
          background: 'linear-gradient(135deg, #2072AF 0%, #7BAFD4 100%)',
          color: 'white'
        }}
      >
        <Box sx={{ mb: 4 }}>
          <CheckCircleIcon 
            sx={{ 
              fontSize: 80, 
              color: 'rgba(255, 255, 255, 0.9)',
              mb: 2 
            }} 
          />
        </Box>
        
        <Typography 
          variant="h3" 
          component="h1" 
          gutterBottom
          sx={{ 
            fontWeight: 'bold',
            mb: 3,
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
          }}
        >
          {t('ThankYouTitle')}
          <br />
          {t('ThankYouTitle2')}
        </Typography>
        
        <Typography 
          variant="h6" 
          sx={{ 
            mb: 4,
            opacity: 0.9,
            lineHeight: 1.6
          }}
        >
          {t('ThankYouMessage')}        
          <br />
          {t('SessionEnded')}
        </Typography>
        
        <Button
          variant="contained"
          onClick={handleGoHome}
          sx={{
            bgcolor: 'rgba(255, 255, 255, 0.2)',
            color: 'white',
            px: 4,
            py: 1.5,
            fontSize: '1.1rem',
            fontWeight: 'bold',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.3)',
            },
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.3)'
          }}
        >
          {t('GoToHomepage')}
        </Button>
      </Paper>
      
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          {t('MirukuruTagline')}
        </Typography>
      </Box>
    </Container>
  );
}

export default ThankYou;